import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'app-tds-certificate',
  templateUrl: './tds-certificate.component.html',
  styleUrls: ['./tds-certificate.component.scss'],
 })

export class TdsCertificateComponent implements OnInit {
  retailerinfo: any;
  retPAN: any;
  selectedQuarter = "Q1";
  selectedYear: any = "2022-23";
  pdfurl: any;
  pdfName: any;
  yearArray: any[];
  constructor(private auth: AuthService, private toast: ToastrService, private ngxService: NgxUiLoaderService) { }

  ngOnInit() {
    this.retPAN = localStorage.getItem('PAN');
    this.getCurrentFinancialYear();

  }

  callAPITdsCertificate() {
    if (this.selectedQuarter == undefined || this.selectedYear == undefined) {
      this.toast.error("Please select year or quarter");
    } else {
      this.ngxService.start();
      this.retailerinfo = [this.retPAN, this.selectedQuarter, this.selectedYear, 'retailer']

      this.auth.downloadTds2(this.retailerinfo).subscribe((res: any) => {
        this.ngxService.stop();
          // var file = new Blob([res], { type: 'application/pdf' })
          var fileURL = res.object;
    
    // if you want to open PDF in new tab
          // window.open(fileURL); 
          var a         = document.createElement('a');
          a.href        = fileURL; 
          a.target      = '_blank';
          a.download    = 'TDSCertificate.pdf';
          document.body.appendChild(a);
          a.click();
        
       
      },
      (error) => {
        this.ngxService.stop();
        this.toast.error("No TDS Certificate available on selected period.");
        console.log('getPDF error: ',error);
      }
    );

    //     if (res.status_code == 200) {
    //       this.pdfurl = res.url;
    //       var data = this.pdfurl.split('/');;
    //       this.pdfName = data[4];
    //     } else {
    //       this.pdfurl = 'false';
    //     }
    //   }, err => {
    //     this.ngxService.stop();
    //     if (err.status == 400) {
    //       this.pdfurl = 'false';
    //     }

    //   })
    }
  }


  downloadTdsCertificate() {
    window.open(this.pdfurl);
    this.pdfName = '';
  }

  selectQuarter(event) {
    this.selectedQuarter = event;
    this.pdfurl = 'true';
    this.pdfName = '';
  }

  selectYear(event) {
    this.selectedYear = event.value;
    this.pdfurl = 'true';
    this.pdfName = '';
  }

  getCurrentFinancialYear() {
    var financial_year = "";
    var today = new Date();

    if ((today.getMonth() + 1)) {
      financial_year = today.getFullYear() + "-" + (today.getFullYear() % 100 + 1)
    } else {
      financial_year = today.getFullYear() + "-" + (today.getFullYear() % 100 + 1)
    }
    var data = [];
    data.push(financial_year);
    data.push("2023-24");

    if (financial_year == "2022-23") {
      this.yearArray = data;
      // console.log('if',this.yearArray);
    } else {
      this.yearArray = [...data, "2022-23"]
      // console.log('else',this.yearArray);
    }
  }
}
